<template>
  <router-view />
</template>

<script>
export default {
  name: 'Setting'
}
</script>
